/**
 * Configuration centralisée des variables d'environnement
 * Source unique de vérité pour toutes les variables d'environnement du projet
 *
 * ⚠️  RÈGLE DE SÉCURITÉ :
 *     La clé API Resend (RESEND_API_KEY) ne doit JAMAIS apparaître ici.
 *     Elle est stockée uniquement dans les secrets Supabase Edge Functions.
 */

// ============================================================================
// SUPABASE
// ============================================================================

export const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

export const SUPABASE_ENABLED = !!(SUPABASE_URL && SUPABASE_ANON_KEY);

export function requireSupabase(): void {
  if (!SUPABASE_ENABLED) {
    throw new Error(
      'Supabase non configuré. Vérifiez VITE_PUBLIC_SUPABASE_URL et VITE_PUBLIC_SUPABASE_ANON_KEY dans .env'
    );
  }
}

// ============================================================================
// EMAIL — variables publiques uniquement (pas de clé API ici !)
// ============================================================================

/**
 * Mode email :
 *   'console' → affiche dans la console (développement, défaut)
 *   'edge'    → appelle l'Edge Function Supabase send-email (production)
 *
 * Définir VITE_EMAIL_MODE=edge dans .env (Vercel) pour activer l'envoi réel.
 */
export const EMAIL_MODE: 'console' | 'edge' =
  (import.meta.env.VITE_EMAIL_MODE as 'console' | 'edge') === 'edge' ? 'edge' : 'console';

/**
 * Adresse expéditeur affichée côté front (pour logs / debug uniquement).
 * La vraie valeur utilisée par Resend est dans le secret RESEND_FROM_EMAIL de l'Edge Function.
 */
export const RESEND_FROM_EMAIL =
  import.meta.env.VITE_RESEND_FROM_EMAIL || 'noreply@tp13.fr';

/**
 * Adresse reply-to affichée côté front (pour logs / debug uniquement).
 */
export const RESEND_REPLY_TO =
  import.meta.env.VITE_RESEND_REPLY_TO || 'admin@tp13.fr';

// Alias de compatibilité (anciens imports)
/** @deprecated Utiliser EMAIL_MODE === 'edge' */
export const RESEND_ENABLED = EMAIL_MODE === 'edge';
/** @deprecated Ne jamais exposer de clé API côté client */
export const RESEND_API_KEY = '';

// ============================================================================
// MAKE.COM (Webhook)
// ============================================================================

export const MAKE_WEBHOOK_URL = import.meta.env.VITE_MAKE_WEBHOOK_URL || '';
export const MAKE_WEBHOOK_ENABLED = MAKE_WEBHOOK_URL.trim().length > 0;

// ============================================================================
// TIMEOUTS & RETRY
// ============================================================================

export const SUPABASE_TIMEOUT = 20000;
export const SUPABASE_RETRY_COUNT = 3;
export const SUPABASE_RETRY_DELAY = 1500;

// ============================================================================
// HELPERS
// ============================================================================

export function logEnvConfig(): void {
  if (import.meta.env.DEV) {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('🔧 [ENV CONFIG]');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log(`✅ Supabase: ${SUPABASE_ENABLED ? 'ENABLED' : '❌ DISABLED'}`);
    console.log(`📧 Email mode: ${EMAIL_MODE.toUpperCase()}`);
    console.log(`🔗 Make.com webhook: ${MAKE_WEBHOOK_ENABLED ? 'ENABLED' : 'DISABLED'}`);
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
  }
}
